import {getLabels, generateLabels} from '../../../../_legacy/Form/services/formService';
import {getStorageItem, setStorageItem} from '../../../../services/storageService';
import {serializeLabels} from '../serializers/labels';
import {excecutePrintLabels} from '../../../../_shared/GWTBridge/invoke/procMain';
import {storageKeys} from '../../../../constants/StorageKeys';
import {isOnServer, getHasModalChild} from '../../../../_shared/GWTBridge/invoke/netForm';
import {FormLabels, FormLabel} from '../../../../_legacy/Form/stores/Form';
import {formsStore} from '../../../../_legacy/Form/stores/FormsStore';
import {showErrorMessage} from '../../../../_shared/Messages/actions/MessageActions';
import {getLocalizedText, texts} from '../../../../constants/TextConst';
import {isRTL} from '../../../../Localization';

export async function initFormLabels(isProcessServerAnswerGWT: boolean) {
    if (
        !formsStore.currentForm ||
        formsStore.currentForm.isRecon ||
        formsStore?.currentForm?.isHTML ||
        getHasModalChild()
    ) {
        return;
    }

    const labelsData = await getLabels(formsStore.currentForm, isProcessServerAnswerGWT);
    const formLabels: FormLabels = serializeLabels(labelsData);

    formsStore.currentForm?.setFormLabels(formLabels);
}

export async function setLabelsStorage(label, lines, clear, print) {
    const storageName = `${formsStore.currentForm.name}-${storageKeys.LABELS}`;
    await setStorageItem(storageName, JSON.stringify({label, lines, clear, print}));
}

export async function setLabelSettings(label, lines, clear, print) {
    const {formLabels} = formsStore.currentForm;
    formLabels.label = label;
    formLabels.lines = lines;
    formLabels.clean = clear;
    formLabels.print = print;
}

export async function setLabelsState() {
    const storageName = `${formsStore.currentForm.name}-${storageKeys.LABELS}`;
    const labelParams = await getStorageItem(storageName);
    const labelData = labelParams[storageName];

    const {formLabels} = formsStore.currentForm;

    if (labelData) {
        const data = JSON.parse(labelData);
        const {label, lines, clear, print} = data;

        formLabels.label = label;
        formLabels.lines = lines;
        formLabels.clean = clear;
        formLabels.print = print;

        formLabels.selected = formLabels.labels
            .filter((labelData: FormLabel) => labelData.value === formLabels.label)
            .pop();
    }

    if (!formLabels.selected) {
        formLabels.selected = formLabels.labels[0];
    }
}

export async function quickPrintLabels(isPopup?: boolean) {
    if (!formsStore.currentForm || isOnServer()) {
        return;
    }

    await initFormLabels(false);

    if (!formsStore.currentForm.hasLabels || formsStore.currentForm.formLabels.mayprint !== '1') {
        // isRTL
        const textHE = 'הדפסת המדבקות אינה זמינה.';
        const textEN = 'Print labels is not availible';

        const moreInfoHe = 'אפשר להדפיס מדבקות רק לאחר הגדרת מדבקות ועם הרשאות מתאימות';
        const moreInfoEn =
            'Labels can only be printed after setting up labels and with appropriate permissions';

        const txt = isRTL() ? textHE : textEN;
        const moreIn = isRTL() ? moreInfoHe : moreInfoEn;

        const props = {
            title: txt,
            moreInfo: moreIn,
            confirmButtonText: getLocalizedText(texts.confirmLabel),
            onConfirm: () => {},
            onClose: () => {}
        };

        showErrorMessage(props);
        return;
    }

    await setLabelsState();
    await printLabels(isPopup, true);
}

export async function printLabels(isPopup: boolean, print: boolean) {
    let {lines, clean, label} = formsStore.currentForm.formLabels;

    lines = isPopup ? 'false' : lines === '1' ? 'true' : 'false';
    clean = clean === '1' ? 'true' : 'false';

    await generateLabels(formsStore.currentForm, label, lines, clean);

    if (print) {
        excecutePrintLabels();
    }
}
